import { defineAsyncComponent, markRaw, type Component } from 'vue'
import FormAutocomplete from '../components/FormAutocomplete.vue'
import FormInputCurrency from '../components/FormInputCurrency.vue'
import FormInputDate from '../components/FormInputDate.vue'
import FormInputText from '../components/FormInputText.vue'
import FormListEditor from '../components/FormListEditor.vue'
import { ComponentType } from './claim-editor'

/* FormCodeInput renders other widgets, so it loads lazily to avoid an import cycle */
const widgetMap: Record<ComponentType, Component> = {
  [ComponentType.AUTOCOMPLETE]: markRaw(FormAutocomplete),
  [ComponentType.LIST]: markRaw(FormListEditor),
  [ComponentType.TEXT]: markRaw(FormInputText),
  [ComponentType.DATE]: markRaw(FormInputDate),
  [ComponentType.CURRENCY]: markRaw(FormInputCurrency),
  [ComponentType.CODES]: defineAsyncComponent(
    () => import('../components/FormCodeInput.vue'),
  ),
}

export const resolveWidget = (component: ComponentType | Component) =>
  typeof component === 'string' ? widgetMap[component] : component
